import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PawPrint } from 'lucide-react';

export default function ShortCodeRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      // Redirect to /tag/{code}
      // This handles: /sp001 → /tag/sp001, /sp245 → /tag/sp245
      navigate(`/tag/${code}`, { replace: true });
    }
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center">
        <PawPrint className="w-12 h-12 text-primary animate-pulse mb-4" />
        <p className="text-muted-foreground">Redirecting...</p>
      </div>
    </div>
  );
}
